import React, { useState } from 'react';
import {
  Divider,
  Space,
  Typography,
} from 'antd';

import {
  WarningLineCard,
  CategoryPricingSlabsView,
  getDefaultRevenuePricing,
  convertPricingToArray,
} from './PricingSlabsView';

const { Text } = Typography;

export const TagSpecificPricingView = ({ pricing, product, currency }) => {
  const isDefault = !pricing;
  const defaultPricing = getDefaultRevenuePricing({ product });
  const pricingArray = convertPricingToArray({
    pricing: pricing || defaultPricing,
    currency,
  });
  return <>
    {
      <>
        <Divider>Admin Only</Divider>
        <Space direction='vertical' size={0}>
          <Text strong>{isDefault ? 'Using Default Pricing' : 'Tag Specific Pricing is set'}</Text>
          <Text>Pricing overides any client level pricing.</Text>
          <WarningLineCard />
        </Space>
      </>
    }
    <CategoryPricingSlabsView tiers={pricingArray} />
  </>;
}
